import { XCircleIcon } from '@heroicons/react/solid'
import { keys } from 'lodash'
import CartSingleItem from './CartSingleItem'
import { useRouter } from 'next/router'
import { handleDuplicateOrder } from '../../helpers/checkout'
import { useState } from 'react'
import Loader from '../Loader'
import ConfirmDialog from '../Modals/ConfirmDialog'
import { ModalStore } from '../../state/ModalStore'
import { nanoid } from 'nanoid'
import { NoticeStore } from '../../state/NoticeStore'
import { getErrorMessage } from '../../helpers/utils'
// @todo Remove Unsealed Fee

export function CartRow({
    id,
    item,
    addOns,
    order_id,
    removeRow,
    mapped_metas,
}) {
    const router = useRouter()
    const [loading, setLoading] = useState(false)

    //console.log('CartRow item', item)

    const addModal = ModalStore((state) => state.add)
    const addNotice = NoticeStore((state) => state.add)

    const handleRemove = (key) => {
        const onConfirm = async () => await removeRow(key)
        addModal(
            <ConfirmDialog
                onConfirm={onConfirm}
                title={'Delete Item'}
                description={'Are you sure you want to remove this item?'}
            />,
        )
    }

    const handleCheckout = async () => {
        try {
            setLoading(true)

            // Extract key from item data
            const getItemKey = (itemData) =>
                itemData?.find((data) => data.name === '_key')?.value

            // Get main item key
            const itemKey = getItemKey(item.item_data)
            if (!itemKey) {
                throw new Error('Main item key not found')
            }

            // Process add-ons once to get both keys and item keys
            const validAddOns = addOns.filter(
                (addOn) => addOn.key && getItemKey(addOn.item_data),
            )
            const addOnKeys = validAddOns.map((addOn) =>
                getItemKey(addOn.item_data),
            )
            const addOnItemKeys = validAddOns.map((addOn) => addOn.key)

            // Combine all keys and build arrays
            const allKeys = [itemKey, ...addOnKeys]
            const lineItemHash = [item.key, ...addOnItemKeys]

            // Make API call
            const response = await handleDuplicateOrder({
                order_id,
                keys: allKeys,
                cartHashKeys: lineItemHash,
            })

            if (!response?.new_order_id) {
                throw new Error('Failed to create duplicate order')
            }

            // Navigate to checkout page
            const checkoutUrl = `/single-checkout?order=${response.new_order_id}`
            router.push(checkoutUrl)
        } catch (error) {
            console.error('Checkout failed:', error)
            addNotice({
                type: 'error',
                children: getErrorMessage(error),
            })
        } finally {
            setLoading(false)
        }
    }

    /**
     * 31st May 2025
     * So Now instead of removing cart items once payment is done, we will simply move this order to pending payment
     * so everybody know which order customer tried to pay but did not and also customer see this order as pending rather than cart
     * and since we already moving it to pending payment, we can also move its cart keys from cart
     */

    // const mayBeUpdateOrderAndRemoveCartKeys = async (order, cartKeys) => {
    //     try {
    //         if (cartKeys && order?.customer_id) {
    //             await CartAPI.removeItems(cartKeys)
    //         }
    //     } catch (e) {
    //         console.error(
    //             'Error updating order or removing cart keys:',
    //             getErrorMessage(e),
    //         )
    //     }
    // }

    return (
        <div data-element-type="cart-row" className="border-b pb-6 mb-6">
            {loading && <Loader />}
            <CartSingleItem
                id={id}
                handleCheckout={handleCheckout}
                item={item}
                mapped_metas={mapped_metas}
                order_id={order_id}
            />

            {keys(addOns).length > 0 && (
                <div className="border-y py-4 my-4">
                    <h3 className="text-lg font-semibold text-gray-800">
                        Additional Products
                    </h3>
                    {addOns.map((addOn) => {
                        return (
                            <CartSingleItem
                                handleRemove={handleRemove}
                                isAddOn
                                id={mapped_metas[addOn.key]}
                                key={nanoid()}
                                item={addOn}
                            />
                        )
                    })}
                </div>
            )}

            <div className="mt-5">
                <button
                    type="button"
                    onClick={() => handleRemove(item.key)}
                    className="mt-2 flex items-center text-sm text-gray-400 hover:text-olh">
                    <XCircleIcon className="w-5 h-5 mr-1" />
                    <span>Remove</span>
                </button>
            </div>
        </div>
    )
}
